<div class="hf-price-breakup-wrapper">
  <div class="content-grid">
    <div class="plan-details-wrapper">
      <div class="header">
        <div class="top-content">
          <div class="logo" [ngClass]="{'h40': qparamPlans === 'plus' && util.isMobile()}">
            <img [src]="qparamPlans === 'essentials' ? 
                          util.isMobile() ? '/assets/images/health-first/hf-essential-plan-light.svg':
                          '/assets/images/health-first/hf-essential-plan.svg': 
                          util.isMobile() ? '/assets/images/health-first/hf-plus-plan-light.svg': 
                          '/assets/images/health-first/hf-plus-plan.svg'" alt="health-first logo" />
          </div>
          <div class="plan-price">
            <div class="title">
              Plan Price
            </div>
            <div class="price">
              {{selectedPlan?.yearly?.amount|currency:'INR':'symbol':'0.0-0'}}
            </div>
          </div>
        </div>
        <div class="bottom-content">
          <div class="info-img">
            <img [src]="util.isMobile() ? '/assets/images/health-first/hf-info-active-icon.svg':'/assets/images/health-first/hf-info-icon.svg'" alt="info icon png">
          </div>
          <div class="text" [innerHTML]="priceBreakupInfo.activationText + userPhone">
          </div>
        </div>
      </div>
      <div class="critical-illness-wrapper">
        <div class="header-wrapper">
          <div class="title">
            <div class="text">
              Critical illness
            </div>
            <mat-icon (click)="openDialogOrBottomSheet()">info</mat-icon>
          </div>
          <div class="toggler-wrapper">
            <mat-slide-toggle [(ngModel)]="breakupGroup.get('critical').value" (change)="onToggleChange($event, true)"></mat-slide-toggle>
          </div>
        </div>
        <div class="header-desc">
          {{priceBreakupInfo.illnessInfoText}}
        </div>
      </div>
      <div class="select-people-cover" *ngIf="breakupGroup.get('critical').value">
        <app-select [data]="peopleOptions" label="person" formFieldClass="hf-select-people" panelClass="hf-cover" placeHolder="person" [group]="breakupGroup" [control]="breakupGroup.get('people')" (onChange)="onPeopleChange($event)" appearance="outline"></app-select>
        <app-select [data]="planOptions" label="cover amount" formFieldClass="hf-select-people" panelClass="hf-cover" placeHolder="cover amount" [group]="breakupGroup" [control]="breakupGroup.get('plan')" (onChange)="onPlanChange($event)" appearance="outline"></app-select>
      </div>
      <!-- next phase -->
      <div class="suggestion" *ngIf="false">
        <div class="title">
          <div class="icon">
            <img src="/assets/images/health-first/shield-check.svg" alt="shield icon">
          </div>
          <div class="text">
            {{priceBreakupInfo.insurancePitchText}}
          </div>
        </div>
        <div class="price">
          {{1000|currency:'INR':'symbol':'0.0-0'}}
        </div>
      </div>
      <div class="suggestion-1" *ngIf="!breakupGroup.get('critical').value">
        <div class="img-wrapper">
          <img src="/assets/images/health-first/hf-shield.svg" alt="hf shield" />
        </div>
        <div class="text" [innerHTML]="priceBreakupInfo?.insurancePitchText1">
        </div>
      </div>
    </div>
    <div class="header" *ngIf="util.isMobile()">
      <div class="title">
        Price Breakup
      </div>
    </div>
    <div class="plan-price-breakup-wrapper">
      <div class="top-content">
        <div class="header" *ngIf="!util.isMobile()">
          <div class="title">
            Price Breakup
          </div>
        </div>
        <div class="content">
          <div class="list">
            <div class="list-item" *ngFor="let item of priceBreakups">
              <div class="text">
                {{item.title}}
              </div>
              <div class="price">
                <span class="minus">{{item.title === 'Discount' ? '-':''}}</span> {{item.price|currency:'INR':'symbol':'0.0-0'}}
              </div>
            </div>
            <div class="hr"></div>
          </div>
          <div class="total-wrapper">
            <div class="title">
              Payable amount
            </div>
            <div class="total-payable-price">
              {{totalPayableAmount|currency: 'INR':'symbol':'0.0-0'}}
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-content" *ngIf="!util.isMobile()">
        <app-button [label]="'Pay ₹' + totalPayableAmount" btnClass="hf-primary-btn" [isLoading]="isLoading" (btnClick)="onPayClick()"></app-button>
      </div>
    </div>
  </div>
</div>
<div class="docked-btn" *ngIf="util.isMobile()">
  <app-button [label]="'Pay ₹' + totalPayableAmount" btnClass="hf-primary-btn" [isLoading]="isLoading" (btnClick)="onPayClick()"></app-button>
</div>

<ng-template #dialogRef>
  <div class="dialog-wrapper">
    <app-close-btn [type]="util.isMobile() ? 'sheet': 'dialog'" top="5px" right="5px"></app-close-btn>
    <div class="header">
      <div class="header-content">
        <div class="title">
          {{priceBreakupInfo.dialogInfo.title}}
        </div>
        <div class="sub-title">
          {{priceBreakupInfo.dialogInfo.subTitle}}
        </div>
      </div>
      <div class="img-wrapper">
        <img src="/assets/images/health-first/hf-shield-1.svg" alt="shield logo" />
      </div>
    </div>
    <div class="content">
      <div class="strong-content">
        {{priceBreakupInfo.dialogInfo.strongContent}}
      </div>
      <div class="list-content">
        <ol>
          <li *ngFor="let item of priceBreakupInfo.dialogInfo.list">
            {{item}}
          </li>
        </ol>
      </div>
    </div>
    <div class="action">
      <app-button [label]="priceBreakupInfo?.dialogInfo?.proceedBtnLabel" btnClass="hf-primary-btn" (btnClick)="onCriticalSelected()"></app-button>
      <button class="no-btn" mat-button (click)="onCriticalRejected()">{{priceBreakupInfo.dialogInfo.noBtnLabel}} </button>
    </div>
  </div>
</ng-template>